import { TRowComponentProps } from '@libs/types';
import React, { MouseEventHandler } from 'react';
import { RowEnum } from '../../../types/enums';
import { RowRegular } from './RowRegular';
import { Selector } from './Selector';

export type TRowComponent = {
    handleClick: MouseEventHandler<HTMLButtonElement>;
} & TRowComponentProps;

const RowComponent: React.FC<TRowComponent> = ({ handleClick, ...props }) => {
    switch (props.id) {
        case RowEnum.ROW_REGULAR:
            return <RowRegular handleClick={handleClick} {...props} />;
        case RowEnum.SELECTOR_REGULAR:
            return <Selector handleClick={handleClick} {...props} />;
        default:
            return <RowRegular handleClick={handleClick} {...props} />;
    }
};

export default RowComponent;
